let generation = 0

export function getAuthGeneration() {
  return generation
}

export function invalidateAuthGeneration() {
  generation += 1
}
